import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectExperimentVariant } from '../ducks/AbTest.duck';
import { ExperimentVariant } from '../abTest';

export function useExperiment({ 
  id, 
  variants = {}, 
  defaultVariant = ExperimentVariant.CONTROL,
  enabled = true
}) {
  const activeVariant = useSelector(selectExperimentVariant(id));
  const currentVariant = activeVariant || defaultVariant;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (activeVariant) {
      console.info(`Experiment: ${id} - variant: ${activeVariant} is selected`);
    } else {
      console.warn(
        `Experiment: ${id} - missing active variant - using ${defaultVariant} as a fallback`
      );
    }

    if (typeof window !== 'undefined') {
      const storageKey = `ab_tracked_${id}_${currentVariant}`;
      const hasBeenTracked = sessionStorage.getItem(storageKey);

      if (!hasBeenTracked) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'ab_test_impression',
          experiment_id: id,
          experiment_variant: currentVariant,
        });

        sessionStorage.setItem(storageKey, 'true');
        console.info(`Experiment: ${id} - variant: ${currentVariant} pushed to dataLayer`);
      }
    }
  }, [id, currentVariant, activeVariant, defaultVariant, enabled]);

  // Jeśli test nie jest enabled, wymuszamy brak wyrenderowanej treści (null)
  if (!enabled) {
    return {
      Variant: null,
      currentVariant: defaultVariant,
      isControl: true,
      isVariantA: false,
    };
  }

  const selectedContent = variants[currentVariant] || variants[defaultVariant] || null;

  return {
    Variant: selectedContent, // Zwracamy element JSX, a nie funkcję
    currentVariant,
    isControl: currentVariant === ExperimentVariant.CONTROL,
    isVariantA: currentVariant === ExperimentVariant.VARIANT_A,
  };
}